import React, {useState, useEffect} from "react";
import axios from "axios";
import CartItem from "./CartItem";
import "./CentralArea.css";
import {motion, AnimatePresence} from "framer-motion";
import cartItem from "./CartItem";
import {ClipLoader} from "react-spinners";

const swipeVariants = {
    enter: (direction) => ({
        x: direction > 0 ? 100 : -100, // Slide da destra o sinistra
        opacity: 0,
    }),
    center: {
        x: 0,
        opacity: 1,
        transition: {duration: 0.3},
    },
    exit: (direction) => ({
        x: direction > 0 ? -100 : 100, // Esce verso sinistra o destra
        opacity: 0,
        transition: {duration: 0.3},
    }),
};


const CentralArea = ({
    product,
    cartItems,
    setCartItems,
    view,
    selectedOptions,
    selectedVariation,
    slug,
    navigateToView,
    setSelectedColorLabel,
    selectedColorLabel,
    step
}) => {
    const [iframeUrl, setIframeUrl] = useState("https://partner.psicopatici.com");
    
    const [showNewsletter, setShownewsletter] = useState(true);
    const [totaleCarrello, setTotaleCarrello] = useState(0, 0);
    const isProd = process.env.REACT_APP_PROD === 'true';
    const apiProdUrl = process.env.REACT_APP_API_PROD_URL;
    const apiStageUrl = process.env.REACT_APP_API_STAGE_URL_V2;
    const apiToken = process.env.REACT_APP_API_TOKEN;
    
    // 3. Definiamo la BASE_URL
    const BASE_URL = isProd ? apiProdUrl : apiStageUrl;
    // Funzione per aggiungere un prodotto alla cassa
    const addToCart = (product) => {
        setCartItems((prevItems) => [...prevItems, product]);
    };
    
    
    //algoritmo per la somma totale del carrello
    useEffect(() => {
        const total = cartItems.reduce((acc, item) => {
            // 1. Recuperiamo i prezzi
            const originalPrice = parseFloat(item.price);
            const salePrice = item.sale_price ? parseFloat(item.sale_price) : null;
            
            // 2. DECISIONE PREZZO: Se c'è un prezzo scontato valido, usiamo quello, altrimenti il prezzo pieno
            const basePriceToUse = (salePrice !== null && salePrice < originalPrice) 
                ? salePrice 
                : originalPrice;

            const itemQty = parseInt(item.qty);
            
            // 3. Calcolo extra opzioni (resta invariato)
            let optionPriceAdjustment = 0;
            
            if (item.options && item.options.optionCartValue) {
                // Gestione universale (sia se è array sia se è oggetto)
                if (Array.isArray(item.options.optionCartValue)) {
                    item.options.optionCartValue.forEach(container => {
                        Object.values(container).forEach(optArr => {
                            optArr.forEach(opt => optionPriceAdjustment += parseFloat(opt.affect_price || 0));
                        });
                    });
                } else {
                    Object.values(item.options.optionCartValue).forEach(optionItems => {
                        optionItems.forEach(option => {
                            optionPriceAdjustment += parseFloat(option.affect_price || 0);
                        });
                    });
                }
            }
            
            // 4. Somma finale usando il 'basePriceToUse' corretto
            return acc + ((basePriceToUse + optionPriceAdjustment) * itemQty);
        }, 0);
        
        setTotaleCarrello(total.toFixed(2));
    }, [cartItems]);
    
    
    const SkeletonCard = () => (
        <div className="product-card skeleton">
        <div className="skeleton-image"></div>
        <div className="skeleton-details">
        <div className="skeleton-line"></div>
        <div className="skeleton-line short"></div>
        </div>
        </div>
    );
    
    
    // Catalogo dei prodotti
    const Catalog = () => {
        const [products, setProducts] = useState([]);
        const [loading, setLoading] = useState(true);
        const [error, setError] = useState(null);
        
        useEffect(() => {
            let updateSlug = localStorage.getItem("updateSlug");
            const urlParams = new URLSearchParams(window.location.search);
            var slug =  urlParams.get("slug") || urlParams.get("homeCategory") || "home-totem";
            
            if (slug == "null") {
                slug = "home-totem";
            }
            
            const fetchProducts = async () => {
                try {
                    const url = `${BASE_URL}/product-categories/slug`;
                    const response = await axios.get(
                        url,
                        {
                            params: {
                                per_page:100,
                                slug:slug,
                            },
                            headers: {
                                'X-Site-Token': apiToken,
                            },
                        }
                    );
                    
                    if (response.data && response.data.data && response.data.data.products) {
                        const fetchedProducts = response.data.data.products.map((product) => ({
                            id: product.id,
                            image: "https://cdn.psicopaticiservice.com/" + product.image || "https://via.placeholder.com/300x400",
                            name: product.name,
                            price: product.price,
                            sale_price: product.sale_price,
                            slug: product.slug,
                            colors: product.colors || [],
                        }));
                        setProducts(fetchedProducts);
                        setLoading(false);
                    } else {
                        setProducts([]);
                    }
                } catch (err) {
                    console.error("Errore durante il recupero dei prodotti:", err);
                    setError("Errore durante il caricamento dei prodotti.");
                }
            };
            
            fetchProducts();
        }, []);
        
        if (loading) {
            return (
                <div className="catalog">
                <div className="product-grid">
                {Array.from({length: 8}).map((_, index) => (
                    <SkeletonCard key={index}/>
                ))}
                </div>
                </div>
            );
        }
        
        if (error) {
            return <p>{error}</p>;
        }
        
        return (
            <div className="catalog">
            <div className="product-grid">
            {products.map((product) => {
                const price = parseFloat(product.price);
                const salePrice = product.sale_price ? parseFloat(product.sale_price) : null;
                const isOnSale = salePrice !== null && salePrice < price;
                
                // Calcolo della percentuale: ((PrezzoVeco - PrezzoNuovo) / PrezzoVecchio) * 100
                const discountPercentage = isOnSale 
                ? Math.round(((price - salePrice) / price) * 100) 
                : 0;
                
                return (
                    <div key={product.id}
                    onClick={() => {
                        navigateToView("product", product.slug);
                        localStorage.setItem("product-active", true);
                    }}
                    className="product-card"
                    style={{ position: 'relative' }} // Necessario per posizionare il badge
                    >
                    
                    <div className="product-image">
                    <img src={product.image} alt={product.name}/>
                    
                    {/* Badge Nero Percentuale */}
                    {isOnSale && (
                        <div style={{
                            position: 'absolute',
                            top: '10px',
                            left: '10px',
                            backgroundColor: 'black',
                            color: 'white',
                            padding: '4px 8px',
                            fontSize: '12px',
                            fontWeight: 'bold',
                            borderRadius: '2px',
                            zIndex: 1
                        }}>
                        -{discountPercentage}%
                        </div>
                    )}
                    </div>
                    
                    <div className="product-details">
                    <h4 className="product-name">{product.name}</h4>
                    
                    <div className="product-price-container" style={{ display: 'flex', alignItems: 'baseline', gap: '8px' }}>
                    {isOnSale ? (
                        <>
                        {/* Prezzo Scontato (Rosso o Nero come preferisci) */}
                        <span className="product-price-sale" style={{ fontWeight: 'bold' }}>
                        {salePrice.toFixed(2)}€
                        </span>
                        {/* Prezzo Originale Barrato */}
                        <span className="product-price-old" style={{ textDecoration: 'line-through', color: '#888', fontSize: '0.9em' }}>
                        {price.toFixed(2)}€
                        </span>
                        </>
                    ) : (
                        /* Prezzo Normale */
                        <p className="product-price" style={{ fontWeight: 'bold' }}>
                        {price.toFixed(2)}€
                        </p>
                    )}
                    </div>
                    </div>
                    </div>
                );
            })}
            </div>
            </div>
        );
    };
    
    
    
    const ProductEditor = ({ product, slug }) => {
        const [baseImage, setBaseImage] = useState(null);
        const [overlayImages, setOverlayImages] = useState([]);
        const [currentIndex, setCurrentIndex] = useState(0);
        const [loading, setLoading] = useState(true);
        
        const imageOrder = ["image", "image_right", "image_back", "image_left"];
        const CDN = "https://cdn.psicopaticiservice.com/";
        
        const preloadImage = (src) =>
            new Promise((resolve, reject) => {
            const img = new Image();
            img.src = src;
            img.onload = () => resolve(src);
            img.onerror = () => reject();
        });
        
        const buildImagesFromOptions = async (sideIndex) => {
            if (!product?.options?.length) {
                setBaseImage(null);
                setOverlayImages([]);
                return;
            }
            
            const field = imageOrder[sideIndex] || "image";
            
            // per ogni option: usa selezionato, altrimenti default (se esiste)
            const imgs = [];
            for (const opt of product.options) {
                const selectedId = selectedOptions?.[opt.id];
                const value =
                opt.values?.find((v) => v.id === selectedId) ||
                opt.values?.find((v) => v.is_default);
                
                const imgPath = value?.[field];
                if (imgPath && imgPath !== "null" && imgPath !== "undefined") {
                    // preload per evitare flash
                    try {
                        await preloadImage(CDN + imgPath);
                        imgs.push(imgPath);
                    } catch {
                        // ignora immagini rotte
                    }
                }
            }
            
            // prima option = base, resto overlay
            setBaseImage(imgs[0] || null);
            setOverlayImages(imgs.slice(1));
        };
        
        useEffect(() => {
            if (!product || !product.slug) return;
            if (product.slug !== slug) return;
            
            const storedIndex = Number(localStorage.getItem("currentImageIndex") || 0);
            const idx = ((storedIndex % imageOrder.length) + imageOrder.length) % imageOrder.length;
            
            setCurrentIndex(idx);
            setLoading(true);
            
            buildImagesFromOptions(idx).finally(() => setLoading(false));
            // eslint-disable-next-line react-hooks/exhaustive-deps
        }, [product, slug, selectedOptions]);
        
        const handleSwipe = async (direction) => {
            const max = imageOrder.length;
            const newIndex =
            (currentIndex + (direction === "left" ? -1 : 1) + max) % max;
            
            setLoading(true);
            try {
                await buildImagesFromOptions(newIndex);
                setCurrentIndex(newIndex);
                localStorage.setItem("currentImageIndex", String(newIndex));
            } finally {
                setLoading(false);
            }
        };
        
        if (loading) {
            return (
                <div className="product-editor d-flex justify-content-center">
                <ClipLoader
                color={"#000000"}
                loading={loading}
                size={50}
                cssOverride={{ borderWidth: "5px" }}
                />
                </div>
            );
        }
        
        return (
            <div className="product-editor">
            <div className="image-gallery">
            {/* overlay (option successive) */}
            {overlayImages.map((img, index) => (
                <motion.img
                key={`overlay-${index}-${currentIndex}`}
                src={`${CDN}${img}`}
                className="option-image"
                variants={swipeVariants}
                onError={(e) => (e.target.style.display = "none")}
                />
            ))}
            
            {/* base (prima option) */}
            {baseImage && (
                <motion.img
                key={`base-${currentIndex}`}
                src={`${CDN}${baseImage}`}
                className="variation-image"
                drag="x"
                dragConstraints={{ left: 0, right: 0 }}
                dragElastic={0}
                variants={swipeVariants}
                onDragEnd={(e, { offset, velocity }) => {
                    const swipe = Math.abs(offset.x) * velocity.x;
                    if (swipe < -50) handleSwipe("left");
                    if (swipe > 50) handleSwipe("right");
                }}
                onError={(e) => (e.target.style.display = "none")}
                />
            )}
            </div>
            </div>
        );
    };
    
    
    
    
    // Componente per la cassa
    const Checkout = () => {
        
        const removeItemFromCart = (id) => {
            setTimeout(() => {
                setCartItems((items) => items.filter((prevItem) => prevItem.id !== id));
            }, 150);
        };
        
        
        const handleNewsletter = (result) => {
            setTimeout(() => {
                setShownewsletter(false);
                document.getElementById("newsletter").checked = result;
            }, 150);
        };
        
        
        return (
            <div className="checkout">
            <div className="d-flex justify-content-between align-items-center"
            style={{padding: "5px 10px 5px 10px", marginBottom: "10px"}}>
            <div className="d-flex align-items-center">
            <i style={{fontSize: "25px", marginTop: "px"}} class="fa-solid fa-cart-shopping me-1"></i>
            <h3 style={{margin: "0", marginTop: "5px", fontWeight: "700"}}>Carrello</h3>
            </div>
            <div>
            <h3 style={{margin: "0", fontWeight: "700"}}>Totale: {totaleCarrello} €</h3>
            </div>
            </div>
            
            {cartItems.length === 0 ? (
                <div style={{textAlign: "center", marginTop: "20px"}}>
                <i className="fas fa-shopping-cart fa-3x" style={{color: "#ccc"}}></i>
                <p style={{fontSize: "18px", color: "#999", marginTop: "10px"}}>
                Il carrello è vuoto. Aggiungi un prodotto prima di procedere al pagamento.
                </p>
                </div>
            ) : (
                <div className={"cart-parent"}>
                
                <div
                className="cart-container" style={{maxHeight: "45vh", paddingBottom: "25px"}}>
                {cartItems.map((item) => (
                    <CartItem key={item.id} id={item.id} item={item} onRemove={removeItemFromCart}/>
                ))}
                </div>
                
                <motion.div
                initial={{y: 100, opacity: 0}}
                animate={{y: 0, opacity: 1}}
                exit={{y: 100, opacity: 1}}
                transition={{duration: 0.5, ease: "easeInOut"}}
                className={`rounded-top-3 fixed-message ${step !== 2 || !showNewsletter ? 'hidden' : ''}`}>
                <p className="newsletter-advice">Se ti iscrivi alla newsletter riceverai un ulteriore
                5% di sconto!</p>
                <div className="d-flex align-items-center gap-1 ms-2">
                <button style={{height: "40px"}} className={"btn btn-white"}
                onClick={() => handleNewsletter(true)}> Accetta
                </button>
                <button style={{height: "40px"}} className={"btn btn-white"}
                onClick={() => handleNewsletter(false)}> Chiudi
                </button>
                </div>
                </motion.div>
                
                
                </div>
            )}
            
            </div>
        );
    };
    
    return (
        <div className="central-area">
        {view === "categories" && <Catalog/>}
        {view === "product" && (
            <ProductEditor 
            key={product?.id}  // Forza il remount al cambio prodotto
            product={product}
            slug={slug}
            />
        )}
        {view === "checkout" && <Checkout/>}
        {view === "iframe" && (
            <iframe
            src={iframeUrl}
            title="External Content"
            style={{width: "100%", height: "99%", border: "none"}}
            ></iframe>
        )}
        </div>
    );
}
;

export default CentralArea;
